<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="approval-main">
      <!-- <el-collapse v-model="collapseActiveName" accordion>
        <el-collapse-item name="1"> -->
          <!-- <template slot="title">
            <el-badge :value="pendingApprovalTotal" class="item"><i class="el-icon-damai-hetong"></i>合同审批123</el-badge>
          </template> -->
          <div>
            <el-tabs v-model="activeName"  type="card">
              <el-tab-pane label="待我审批" name="pendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="pendingApprovalTableHead" @seeExample="seeExample" :tableData="pendingApprovalTableData" :operationArr="pendingApprovalOperationArr" @electricApproveRow="occupancyApproveRow" @electricUnApproveRow="occupancyApproveUnApproveRow" :total="pendingApprovalTotal" :pageNum="pendingApprovalPageNum" :pageSize="pendingApprovalPageSize" @changePagination="changePendingApprovalPagination" />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="approved">
                <table-main :tableHeight="520" :selection="false" :hasOperation="false" :tableHead="approvedTableHead" @seeExample="seeExample" :tableData="approvedTableData" :operationArr="approvedOperationArr" :total="approvedTotal" :pageNum="approvedPageNum" :pageSize="approvedPageSize" @changePagination="changeApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="sponsored">
                <table-main :tableHeight="520" :selection="false" :hasOperation="false" :tableHead="sponsoredTableHead" @seeExample="seeExample" :tableData="sponsoredTableData" :operationArr="sponsoredOperationArr" :total="sponsoredTotal" :pageNum="sponsoredPageNum" :pageSize="sponsoredPageSize" @changePagination="changeSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        <!-- </el-collapse-item>
      </el-collapse> -->
    </div>

    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="occupancyApproveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="occupancyApproveMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="occupancyCancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="occupancyPassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="occupancyApproveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="occupancyRejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="occupancyCancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="occupancyUnpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog title="审批进度" :visible.sync="flowDialog" style="margin-top:200px">
      <el-steps :active="currentRate" align-center finish-status="success">
        <el-step :title="applyData.status=='4'?applyData.personName+'已撤回':applyData.personName+'发起审批'" :description="applyData.createTime"></el-step>
        <el-step v-if="applyData.status!='4'" v-for="(item, index) in flowData" :key="item.code" :title="item.statusText" :description="item.approveDate" :status="item.status&&item.status!='0'?item.status=='2' ? 'error' : 'success':''"></el-step>
      </el-steps>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TableMain from "../../../components/Table/TableMain";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import { api } from "../../api/WorkbenchApproval";

export default {
  components: {
    TableMain,
    Breadcrumb,
  },
  name: "workbench-approval",
  data() {
    return {
      yqCode: "",
      breadcrumb: [
        {
          value: "待办事项",
          name: "contract-approval",
        },
        {
          value: "入住申请审批",
        },
      ],
      collapseActiveName: "",
      contractCollapseItemTitle: "合同审批",
      accountCode: "",
      activeName: "pendingApproval",

      // 我发起的
      sponsoredTableHead: [
        {prop: "mainTypeText", label: "承租类型",},
        {prop: "personName", label: "姓名",},
        {prop: "phone", label: "手机号码",},
        {prop: "identityNumber", label: "身份证号",},
        {prop: "enterpriseName", label: "单位名称",},
        {prop: "taxpayerRegisterNumber", label: "纳税人识别号",},
        {prop: 'rentTypeText', label: '申请房型'},
        {prop: 'stayStartTime', label: '预入住日期'},
        {prop: 'leaseTimeLimit', label: '预租期限'},
        {prop: "createTime", label: "申请时间",},
        {prop: "payChannelText", label: "审批进度", example: true},
      ],
      sponsoredTableData: [],
      sponsoredOperationArr: ["details"],
      sponsoredTotal: 0,
      sponsoredPageNum: 1,
      sponsoredPageSize: 10,

      // 待我审批
      pendingApprovalTableHead: [
        {prop: "mainTypeText", label: "承租类型",},
        {prop: "personName", label: "姓名",},
        {prop: "phone", label: "手机号码",},
        {prop: "identityNumber", label: "身份证号",},
        {prop: "enterpriseName", label: "单位名称",},
        {prop: "taxpayerRegisterNumber", label: "纳税人识别号",},
        {prop: 'rentTypeText', label: '申请房型'},
        {prop: 'stayStartTime', label: '预入住日期'},
        {prop: 'leaseTimeLimit', label: '预租期限'},
        {prop: "createTime", label: "申请时间",},
        {prop: "payChannelText", label: "审批进度", example: true},
      ],
      pendingApprovalTableData: [],
      pendingApprovalOperationArr: ["electricApproveRow", "electricUnApproveRow",],
      pendingApprovalTotal: 0,
      pendingApprovalPageNum: 1,
      pendingApprovalPageSize: 10,

      // 我已审批
      approvedTableHead: [
        {prop: "mainTypeText", label: "承租类型",},
        {prop: "personName", label: "姓名",},
        {prop: "phone", label: "手机号码",},
        {prop: "identityNumber", label: "身份证号",},
        {prop: "enterpriseName", label: "单位名称",},
        {prop: "taxpayerRegisterNumber", label: "纳税人识别号",},
        {prop: 'rentTypeText', label: '申请房型'},
        {prop: 'stayStartTime', label: '预入住日期'},
        {prop: 'leaseTimeLimit', label: '预租期限'},
        {prop: "createTime", label: "申请时间",},
        {prop: "approvalStatusText", label: "状态",},
        {prop: "payChannelText", label: "审批进度", example: true},
      ],
      approvedTableData: [],
      approvedOperationArr: ["details"],
      approvedTotal: 0,
      approvedPageNum: 1,
      approvedPageSize: 10,


      flowDialog:false,
      applyData:{},
      chainList:[],
      flowData:{},
      currentRate:0,


      occupancyApproveData: {},
      occupancyApproveDialog: false,
      occupancyApproveMemo: "",
      occupancyUnApproveData: {},
      occupancyApproveRejectDialog: false,
      occupancyRejectMemo: "",
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.accountCode = bus.global.accountCode;
    this.getStayApplyApprovalPendingByAdmin();
  },
  mounted() {
    if (this.$route.params.workType) {
      this.activeName = this.$route.params.workType;
    }
  },
  methods: {
    // 我发起的页码跳转
    changeSponsoredPagination(data) {
      this.sponsoredPageNum = data[0];
      this.sponsoredPageSize = data[1];
      this.getStayApplyByInitiate();
    },

    // 待我审批页码跳转
    changePendingApprovalPagination(data) {
      this.pendingApprovalPageNum = data[0];
      this.pendingApprovalPageSize = data[1];
      this.getStayApplyApprovalPendingByAdmin();
    },

    // 我已审批页码跳转
    changeApprovedPagination(data) {
      this.approvedPageNum = data[0];
      this.approvedPageSize = data[1];
      this.getStayApplyApplyFinishByAdmin();
    },

    // 我发起的
    getStayApplyByInitiate() {
      let reqData = {};
      reqData.pageNum = this.sponsoredPageNum;
      reqData.pageSize = this.sponsoredPageSize;
      reqData.personCode = this.accountCode;
      this.$axios.post(api.getStayApplyByInitiate, reqData)
        .then((res) => {
          let data = res.data.data.list;
          data.map((v) => {
            v.mainTypeText = v.mainType === 0 ? '个人' : '单位'
            v.rentTypeText = v.rentType === 1 ? '床位' : '整租'
            let approvalNode = v.approvalNode || {}
            if (approvalNode.status === '0') {
              v.approvalStatusText = '审批中'
            } else if (approvalNode.status === '1') {
              v.approvalStatusText = '已通过'
            } else if (approvalNode.status === '2') {
              v.approvalStatusText = '已驳回'
            } else if (approvalNode.status === '3') {
              v.approvalStatusText = '已撤回'
            } else if (approvalNode.status === '4') {
              v.approvalStatusText = '已作废'
            }
          });
          this.sponsoredTotal = res.data.data.total;
          this.sponsoredTableData = data;
        })
        .catch(errorHandler("获取我发起的审批数据失败"));
    },

    // 待我审批
    getStayApplyApprovalPendingByAdmin() {
      let reqData = {};
      reqData.pageNum = this.pendingApprovalPageNum;
      reqData.pageSize = this.pendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      this.$axios.post(api.getStayApplyApprovalPendingByAdmin, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              v.mainTypeText = v.mainType === 0 ? '个人' : '单位'
              v.rentTypeText = v.rentType === 1 ? '床位' : '整租'
            });
            this.pendingApprovalTotal = res.data.data.total;
            this.pendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取待我审批数据失败"));
    },

    // 我已审批
    getStayApplyApplyFinishByAdmin() {
      let reqData = {};
      reqData.pageNum = this.approvedPageNum;
      reqData.pageSize = this.approvedPageSize;
      reqData.approveAccountCode = this.accountCode;
      this.$axios.post(api.getStayApplyApplyFinishByAdmin, reqData)
        .then((res) => {
          let data = res.data.data.list;
          data.map((v) => {
            v.mainTypeText = v.mainType === 0 ? '个人' : '单位'
            v.rentTypeText = v.rentType === 1 ? '床位' : '整租'
            let approvalNode = v.approvalNode || {}
            if (approvalNode.status === '0') {
              v.approvalStatusText = '审批中'
            } else if (approvalNode.status === '1') {
              v.approvalStatusText = '已通过'
            } else if (approvalNode.status === '2') {
              v.approvalStatusText = '已驳回'
            } else if (approvalNode.status === '3') {
              v.approvalStatusText = '已撤回'
            } else if (approvalNode.status === '4') {
              v.approvalStatusText = '已作废'
            }
          });
          this.approvedTotal = res.data.data.total;
          this.approvedTableData = data;
        })
        .catch(errorHandler("获取我已审批数据失败"));
    },

    seeExample(data){
      this.$axios.get(`${api.getStayApplyApplyFlow}/${data.code}`, {})
        .then(res=>{
          this.applyData=res.data.data.apply
          this.chainList=res.data.data.chainList
          this.flowData=res.data.data.flow.flowDetails
          if(this.applyData.status && this.applyData.status=='4'){
            this.flowDialog=true;
            this.currentRate=0
            return;
          }
          this.flowData.map(u=>{
            u.statusText=u.accountName
            this.chainList.map(v=>{
              if(v.approveAccountCode==u.accountCode){
                u.approveDate=v.approveDate
                u.status=v.status
                if(v.status=='2'){
                  u.statusText=u.accountName+'已通过'
                } else if(v.status=='3'){
                  u.statusText=u.accountName+'已驳回'
                }
              }
            })
          })

          this.flowData.map(v=>{
            let accountCode = v.accountCode;
            this.chainList.map(u=>{
              if(accountCode == u.approveAccountCode){
                if(u.status=='1'){
                  this.currentRate =+ u.index;
                }else{
                  this.currentRate =+ u.index+1;
                }
              }
            })
          })
          this.flowDialog=true
        })
        .catch(errorHandler("获取审批进度失败"))
    },

    // 审批通过处理
    occupancyApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.occupancyApproveData = data;
      this.occupancyApproveDialog = true;
    },
    // 审批驳回处理
    occupancyApproveUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.occupancyUnApproveData = data;
      this.occupancyApproveRejectDialog = true;
    },

    // 取消通过
    occupancyCancelApprove() {
      this.occupancyApproveMemo = "";
      this.occupancyApproveDialog = false;
    },

    // 确认通过
    occupancyPassSubmit() {
      let approvalNode = this.occupancyApproveData.approvalNode || {}
      let approveData = {
        code: approvalNode.code,
        applyType: approvalNode.applyType,
        approveResult: this.occupancyApproveMemo
      }
      this.$axios.post(api.agreeApprovalNodeApply, approveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.occupancyApproveMemo = "";
            this.occupancyApproveDialog = false;
            nSuccess("审批已通过");
            this.getStayApplyApprovalPendingByAdmin();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回
    occupancyCancelReject() {
      this.occupancyRejectMemo = "";
      this.occupancyApproveRejectDialog = false;
    },

    // 确认驳回
    occupancyUnpassSubmit() {
      let approvalNode = this.occupancyUnApproveData.approvalNode || {}
      let approveData = {
        code: approvalNode.code,
        applyType: approvalNode.applyType,
        approveResult: this.occupancyRejectMemo
      }
      this.$axios.post(api.rejectApprovalNodeApply, approveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.occupancyRejectMemo = "";
            this.occupancyApproveRejectDialog = false;
            nSuccess("审批已驳回");
            this.getStayApplyApprovalPendingByAdmin();
          }
        })
        .catch(errorHandler("驳回失败"));
    },
  },
  watch: {
    activeName(val) {
      if (val === "sponsored") {
        this.sponsoredPageNum = 1;
        this.sponsoredPageSize = 10;
        this.getStayApplyByInitiate();
      } else if (val === "pendingApproval") {
        this.pendingApprovalPageNum = 1;
        this.pendingApprovalPageSize = 10;
        this.getStayApplyApprovalPendingByAdmin();
      } else if (val === "approved") {
        this.approvedPageNum = 1;
        this.approvedPageSize = 10;
        this.getStayApplyApplyFinishByAdmin();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
</style>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
/deep/ .el-step__description {
  margin-top: -8em ;
}
/deep/ .el-dialog__body{
  padding:50px 0 ;
  color: #1362FF ;
}
/deep/.el-step__head.is-success{
  color: #1362FF ;
  border-color: #1362FF ;
}
/deep/.el-step__title.is-success{
  color: #1362FF ;
}
/deep/.el-step__description.is-success{
  color:#1362FF ;
}
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/OccupancyApproval/OccupancyApproval.vue